import React from "react";
import ReactApexChart from "react-apexcharts";

/**
 * Centralized time-based color rules
 */
const TIME_COLORS = {
  HIGH: "#D52143",   // >= 45s
  MEDIUM: "#2F67D8", // 18s – 44s
  LOW: "#5EAA42",    // <= 17s
};

/**
 * Resolve color by time value
 */
const resolveTimeColor = (value) => {
  if (value >= 45) return TIME_COLORS.HIGH;
  if (value > 17) return TIME_COLORS.MEDIUM;
  return TIME_COLORS.LOW;
};

class TimeChart extends React.Component {
  constructor(props) {
    super(props);
    let colors = [];
    const chartData = props?.analysisdata?.details?.question_time_chart || {};
    const categories = chartData.categories || [];
    const series = (chartData.series || []).map((s) => ({
      // name: s.name,
      name: "",
      type: s.type || "bar",
      data: (s.data || []).map((d) => {
        colors.push(resolveTimeColor(d.y))
        return ({
          x: d.name,
          y: d.y,
          fillColor: resolveTimeColor(d.y),
        });
      }),
    }));

    this.state = {
      series: series,
      options: {
        annotations: {
          points: [
            {
              seriesIndex: 0,
              label: {
                borderColor: "#775DD0",
                offsetY: 0,
              },
            },
          ],
        },
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "4px",
            // distributed: true,
            dataLabels: {
              position: "top",
            },
          },
        },

        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}s`,
          style: {
            fontSize: "8px",
            colors: ["black"],
            fontWeight: "bold",
          },
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff"],
          },
        },
        xaxis: {
          labels: {
            style: {
              fontSize: "8px",
              fontWeight: "bold",
            },
          },
          categories: categories,
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Time (secs)",
          }
        },
        legend: {
          show: false,
          customLegendItems: ["≤ 17s", "18s – 44s", "≥ 45s"],
          markers: {
            fillColors: [
              TIME_COLORS.LOW,
              TIME_COLORS.MEDIUM,
              TIME_COLORS.HIGH,
            ],
          },
        },
        fill: {
          type: "solid",
          colors: colors
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} seconds`,
          },
        },
      },
    };
  }

  render() {
    return (
        <div id="chart">
          <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              height={600}
              width="100%"
          />
        </div>
    );
  }
}

export default TimeChart;
